module.exports = __webpack_public_path__ + "static/img/投资移民开户.8b6044e9.svg";